import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Astrology from "./pages/Astrology";
import AdminPanel from "./pages/AdminPanel";
import UserManagement from "./pages/UserManagement";
import Profile from "./pages/Profile";
import Home from "./pages/Home";
import SelfLoveWall from "./pages/SelfLoveWall";
import Journal from "./pages/Journal";
import Community from "./pages/Community";
import LifeCoaches from "./pages/LifeCoaches";
import Shop from "./pages/Shop";
import Referrals from "./pages/Referrals";
import Companion from "./pages/Companion";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import HelpCenter from "./pages/HelpCenter";
import LiveSupport from "./pages/LiveSupport";
import SOSResources from "./pages/SOSResources";
// Using simplified Love Garden with proper level map
import LoveGardenSimple from "./pages/LoveGardenSimple";
import OnboardingFlow from "./pages/OnboardingFlow";
import More from "./pages/More";
import AppPreview from "./pages/AppPreview";
import DivineGuidance from "./pages/DivineGuidance";
import VisionBoard from "./pages/VisionBoard";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import VerifyEmail from "./pages/VerifyEmail";
import Navigation from "./components/Navigation";
import TrackingScripts from "./components/TrackingScripts";
import CookieConsent from "./components/CookieConsent";
// Removed Wallpapers import - feature removed for MVP

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <TrackingScripts />
          <CookieConsent />
          <Routes>
            {/* Public Landing Page */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Authentication Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Legal & Support Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/community-guidelines" element={<CommunityGuidelines />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/live-support" element={<LiveSupport />} />
            <Route path="/sos-resources" element={<SOSResources />} />
            
            {/* App Preview (No Authentication Required) */}
            <Route path="/demo" element={<AppPreview />} />
            <Route path="/preview" element={<AppPreview />} />
            
            {/* Onboarding Route */}
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <OnboardingFlow />
              </ProtectedRoute>
            } />
            
            {/* Admin Panel - Has its own auth check */}
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/app/admin" element={<AdminPanel />} />
            <Route path="/app/admin/users" element={<UserManagement />} />
            
            {/* Protected App Routes */}
            <Route path="/app" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Home />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/wall" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <SelfLoveWall />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/journal" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Journal />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/companion" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Companion />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/love-garden" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <LoveGardenSimple />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/astrology" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Astrology />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/community" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Community />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/more" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <More />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/divine-guidance" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <DivineGuidance />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/vision-board" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <VisionBoard />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/coaches" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <LifeCoaches />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/shop" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Shop />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/referrals" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Referrals />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/profile" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Profile />
                </main>
              </ProtectedRoute>
            } />
            <Route path="/app/subscription-success" element={
              <ProtectedRoute>
                <SubscriptionSuccess />
              </ProtectedRoute>
            } />
            <Route path="/app/subscription-cancel" element={
              <ProtectedRoute>
                <Navigation />
                <main>
                  <Home />
                </main>
              </ProtectedRoute>
            } />
            {/* Wallpapers route removed for MVP - low quality feature */}
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;